import { styled } from "styled-components";

import { ActionButtonItem, PlayIcon } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { setAudioPlayer } from "domains/audioPlayer/actions";
import { getIsAudioVisible } from "domains/audioPlayer/selectors";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";
import { createTopicSelector } from "entities/topics/selectors";

const StyledIcon = styled(PlayIcon)`
  ${iconStyle}
`;

type AudioActionButtonProps = { topicId: string };

export const AudioActionButton = ({ topicId }: AudioActionButtonProps) => {
  const dispatch = useDispatch();
  const topic = useSelector(createTopicSelector(topicId));
  const isAudioVisible = useSelector(getIsAudioVisible);
  const track = useTrack();
  const translate = useTranslate();

  const togglePlayerHandle = () => {
    if (!topic) {
      return;
    }
    const podcast = topic.attachment?.type === "podcast" ? topic.attachment : undefined;
    if (podcast?.url) {
      let audioFile = undefined;
      if (!isAudioVisible) {
        audioFile = {
          id: topic.id,
          name: topic.name,
          image: topic.images?.thumbnail,
          url: podcast.url,
        };
      }
      dispatch(setAudioPlayer(audioFile));
      track({
        entityId: topicId,
        entityName: topic.name,
        entityType: "Topic",
        name: "Play Media",
        secondaryEntityId: podcast.id,
        secondaryEntityName: podcast.title,
        secondaryEntityType: "Podcast",
      });
    }
  };

  return (
    <ActionButtonItem
      label={translate("app.topic.listen_to_overview")}
      icon={<StyledIcon />}
      onClick={togglePlayerHandle}
    />
  );
};
